import { Select, Tag } from 'antd';

// Выбор меток: tags — справочник [{id, name, textColor, bgColor, vid}]
const TagSelect = ({ tags, vid, value, onChange, ...props }) => {
    const options = (tags ?? [])
        .filter((t) => vid == null || t.vid === vid)
        .map((t) => ({ value: t.id, label: t.name, tag: t }));

    const tagRender = ({ value: tagId, closable, onClose }) => {
        const tag = (tags ?? []).find((t) => t.id === tagId);
        if (!tag) return null;
        return (
            <Tag
                color={tag.bgColor || undefined}
                style={{ color: tag.textColor || undefined, marginInlineEnd: 4 }}
                closable={closable}
                onClose={onClose}
            >
                {tag.name}
            </Tag>
        );
    };

    return (
        <Select
            mode="multiple"
            allowClear
            placeholder="Метки"
            options={options}
            tagRender={tagRender}
            value={value}
            onChange={onChange}
            {...props}
        />
    );
};

export default TagSelect;
